import { useEffect } from 'react';
import { useICalContext } from '../contexts/ICalContext';

/**
 * Hook to use iCal events from the centralized context
 * This replaces the old useICalEvents hook to prevent duplicate API calls
 */
const useICalEvents = (icalUrl = null) => {
  const { events, loading, error, lastFetch, updateUrl, refreshEvents, testUrl, isConnected } = useICalContext();

  // Update the URL in the context when it changes
  useEffect(() => {
    // ✅ Validate icalUrl is a valid URL string before passing to updateUrl()
    if (icalUrl !== null) {
      if (typeof icalUrl === 'string' && icalUrl.trim()) {
        const trimmedUrl = icalUrl.trim();
        
        // Basic URL validation
        try {
          new URL(trimmedUrl);
          updateUrl(trimmedUrl);
        } catch (error) {
          console.warn('Invalid iCal URL provided:', icalUrl);
          updateUrl(null); // Clear invalid URL
        }
      } else if (icalUrl === '') {
        updateUrl(null); // Clear empty string
      } else {
        console.warn('Invalid iCal URL type:', typeof icalUrl, icalUrl);
        updateUrl(null);
      }
    } else {
      updateUrl(null);
    }
  }, [icalUrl, updateUrl]);

  return {
    events,
    loading,
    error,
    lastFetch,
    fetchEvents: refreshEvents, // Keep the same API for backward compatibility
    refreshEvents,
    testUrl,
    isConnected,
  };
};

export default useICalEvents;
